// Styles for PrivacyRightsWrapper go here.
import styled, { createGlobalStyle } from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledPrivacyRightsWrapper = styled.div`
  background-color: ${baseVariables.color['base20']};
  margin: ${toRem(32)} auto ${toRem(60)};
  position: relative;

  .display-name {
    text-align: center;
  }

  @media ${baseVariables.mediaQuery.md} {
    margin-top: ${toRem(-50)};
  }
  box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
  border-radius: ${toRem(14)};
  padding: ${toRem(32)} ${toRem(24)};
  @media screen and (max-width: ${toRem(576)}) {
    padding: ${toRem(32)} 0;
    width: 90%;
  }

  .text-center: {
    text-align: center;
  }
  .tab-disable-border {
    box-shadow: none;
    width: ${toRem(327)};
    max-width: 90%;
    .tab-height {
      height: ${toRem(40)};
    }
  }
  .privacy-statement {
    text-align: center;
    width: 55%;
    margin: 0 auto;
  }

  .states-dropdown {
    width: 90%;
    margin: ${toRem(24)} auto;
    @media ${baseVariables.mediaQuery.md} {
      width: 40%;
    }
    @media ${baseVariables.mediaQuery.lg} {
      width: 30%;
    }
  }
  .userName-loader {
    width: ${toRem(300)};
    height: ${toRem(48)};
    margin: 0 auto;
  }
  .privacy-subHeading-loader {
    width: 50%;
    height: ${toRem(200)};
    margin: ${toRem(20)} auto;
  }
  .privacy-rights-loader {
    width: 95%;
    height: ${toRem(200)};
    margin: 0 auto;
  }
`;

export const GlobalStyles = createGlobalStyle`
  body {
    background-color: #f4f4f4 !important;
  }
`;
